var render = function render(){var _vm=this,_c=_vm._self._c;return _c('el-card',{staticClass:"aui-card--fill",attrs:{"shadow":"never"}},[_c('div',{staticClass:"mod-home"})])
}
var staticRenderFns = []

export { render, staticRenderFns }